<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Imagen</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Cantidad</th>
                <th :class="StyleTh">Precio</th>
                <th :class="StyleTh">Precio Total</th>
                
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td>
                    <span v-if="lista.Imagen">
                        <img alt="Imagen" :src="RutaFile+lista.UrlImagen+lista.Imagen" width="90px" height="90px">
                    </span>
                    <span v-else>
                        <img alt="Imagen" src="@/assets/style/image/sin_imagen_180.jpg" width="90px" height="90px">
                    </span>
                </td>
                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                <td><p :class="StyleTd">{{lista.Cantidad}}</p></td>
                <td><p :class="StyleTd">$ {{lista.Precio}}</p></td>
                <td><p :class="StyleTd">$ {{lista.PrecioTotal}}</p></td>
                    
                <td class="align-middle text-end">
                    <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdElementoPaq" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                        <template slot="btnaccion">
                        </template>
                    </CBtnAccion>     
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionElementopaquete';

export default {
    name: 'ListaElementopaquete',
    props:['pObjEnviado'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Elementos del Paquete',
                IsModal: false,
                ShowLoader: true,
                BtnReturnShow: true,
                ShowTitleFirst: true,
                EmitSeccion: EmitEjecuta,
                GoRoute: 'elementopaqueteform',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjPaquete: {},
            RutaFile: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("elementospaquete",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdPaquete: this.ObjPaquete.IdPaquete,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.RutaFile           = res.data.RutaFile;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('elementospaquete/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error("Error al eliminar el registro");
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'paquete',params:{}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objPaquete',JSON.stringify(this.pObjEnviado));
        }

        this.ObjPaquete = JSON.parse(sessionStorage.getItem('objPaquete'));
        this.ConfigList.TitleFirst=this.ObjPaquete.Nombre;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
